export enum UTFCodeEnum {
  LIGHT_TICK = '\u2713',
  LIGHT_CROSS = '\u00D7'
}
